var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0781 9.99023C14.2873 9.99023 16.0781 8.19937 16.0781 5.99023C16.0781 3.7811 14.2873 1.99023 12.0781 1.99023C9.86899 1.99023 8.07812 3.7811 8.07812 5.99023C8.07812 8.19937 9.86899 9.99023 12.0781 9.99023Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1152 18.0059C20.1172 17.8419 20.1172 17.6749 20.1172 17.5059C20.1172 15.0209 16.5352 13.0059 12.1172 13.0059C7.69919 13.0059 4.11719 15.0209 4.11719 17.5059C4.11719 19.9909 4.11719 22.0059 12.1172 22.0059C14.3482 22.0059 15.9572 21.8489 17.1172 21.5689",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.970dae80a8cae5e13e3069b9c2475468.svg";
export { ForwardRef as ReactComponent };